import { render, staticRenderFns } from "./reviewExtend.vue?vue&type=template&id=3effb84b&"
import script from "./reviewExtend.vue?vue&type=script&lang=js&"
export * from "./reviewExtend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports